import React from "react";

// eslint-disable-next-line jsx-a11y/alt-text
const EditorTextoImage = ({ ...props }) => <img {...props} />;

export default EditorTextoImage;
